export const isOnlyBedek = (space) =>
  space?.BEDEK === "Y" && space?.CONTSALE !== "Y";
export const isOnlyContsale = (space) =>
  space?.CONTSALE === "Y" && space?.BEDEK !== "Y";

export const SPACE_MODES = [
  { key: "BEDEK", env: "BDNAME", label: "MODE_BEDEK" },
  { key: "TENANTCHOOSE", env: "CDNAME", label: "MODE_CHOOSE" },
  { key: "CONTSALE", env: "MDNAME", label: "MODE_CONTSALE" },
];

export const buildModeSegments = (row, t, enabled = true, gate = null) => {
  const availableCount = SPACE_MODES.filter((mode) => !!row?.[mode.env]).length;
  return SPACE_MODES.map((mode) => {
    const siteAllows = !gate || gate[mode.key] === "Y";
    return {
      key: mode.key,
      label: t(mode.label),
      active: siteAllows && row?.[mode.key] === "Y",
      disabled:
        !enabled || !row?.[mode.env] || availableCount <= 1 || !siteAllows,
    };
  });
};
